import { mutatorAction } from "satcheljs";
import type { AccountKey } from "owa-client-types";
import { addMinutes, owaDate } from "owa-datetime";
import { OcpsPoliciesFetchState } from "../store/schema/OutlookCloudPoliciesSchema";
import getStore from "../store/store";

const OCPS_POLICIES_REFETCH_INTERVAL_MINUTES = 30;

export const updateAccountFetchStateMutator: (accountKey: AccountKey, fetchState: OcpsPoliciesFetchState, useRefetchInterval?: boolean) => void = mutatorAction("updateAccountFetchState", (accountKey: AccountKey, fetchState: OcpsPoliciesFetchState, useRefetchInterval?: boolean): void => {
    const nextRetryAfter = fetchState === OcpsPoliciesFetchState.Failed && useRefetchInterval
        ? addMinutes(owaDate("UTC"), OCPS_POLICIES_REFETCH_INTERVAL_MINUTES)
        : undefined;
    const existing = getStore().get(accountKey);
    if (existing) {
        existing.fetchState = fetchState;
        existing.retryAfter = nextRetryAfter;
    }
    else {
        getStore().set(accountKey, { policies: {}, fetchState, retryAfter: nextRetryAfter });
    }
});
